import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IntegrationService {
  isEnabled!: false;
  isHubspotEnabled!: false;
  isSalesForceEnabled!: false;
  isTikTokEnabled!: false;
  constructor() { }

  setIntegrationStatus(campaign: any) {
    this.isEnabled = campaign.Integration.IsEnabled;
    this.isHubspotEnabled = campaign.Integration.IsHubspotEnabled;
    this.isSalesForceEnabled = campaign.Integration.IsSalesforceEnabled;
    this.isTikTokEnabled = campaign.Integration.IsTikTokEnabled;
  }
}
